const PageCompanySecurity = () => import('./PageCompanySecurity');

export default {
  path: 'company-security',
  name: 'company-security',
  component: PageCompanySecurity,
  meta: {
    title: 'Configuração de Segurança',
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/company-security/routes.js